@if (showAlert) {
  <div class="lindberg-alert">
    <div>{{alertMessage}}</div>
    <div (click)="closeAlert()" class="lindberg-alert-dismiss"></div>
  </div>
}